<div class="flex p-8 flex-col justify-center items-center">
<mat-dialog-content >
  <div class="flex p-8 flex-col justify-center items-center">
  <img width="128" height="128" class="" src="https://img.icons8.com/cute-clipart/128/ok.png" alt="ok" />
  <h1 class="text-2xl font-extrabold text-center"> Your Order Has Been Placed Successfully</h1>
  <br>
  <h4 class="text-center"> Thank you for the payment, we will keep you updated</h4>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button  mat-dialog-close  class="button-82-pushable  w-full flex" role="button">
    <span class="button-82-shadow w-full flex"></span>
    <span class="button-82-edge w-full flex"></span>
    <span class="button-82-front w-full text flex">
      <div class="flex flex-row gap-4 w-full justify-center">
        <span> OK</span>

      </div>
    </span>
  </button>

</mat-dialog-actions>
</div>